__turbopack_context__.v({
  "entry": "FaqAccordion-module-scss-module__CKPyVW__entry",
  "is-collapsed": "FaqAccordion-module-scss-module__CKPyVW__is-collapsed",
  "is-expanded": "FaqAccordion-module-scss-module__CKPyVW__is-expanded",
  "plus-icon": "FaqAccordion-module-scss-module__CKPyVW__plus-icon",
});
